

















import { Component, Prop } from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { Location } from "vue-router";
import Heading from "../shared/Header.vue";
import PartnerHome from "@/employer/components/landing-pages/PartnerHome.vue";
import EmployerHome from "@/employer/components/landing-pages/EmployerHome.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import AddMfa from "@/employee/components/onboarding/AddMfa.vue";
import * as EmployerRoutes from "@/employer/route-names";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import Products from "@/employer/components/products/Products.vue";

@Component({
  components: {
    Heading,
    GenericLoadingSpinner,
    EmployerHome,
    PartnerHome,
    AddMfa,
    Products
  }
})
export default class Home extends mixins(ErrorsMixin) {
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();

  @Prop({ required: false })
  employerId?: number;

  @Prop({ required: false })
  partnerId?: number;

  @Prop()
  routeToNewEmployee: () => Location;

  get showSpinner () { return this.userStore.loggedIn && !this.showSinglePartner && !this.showSingleEmployer; }

  get showSinglePartner () { return this.partnerId; }

  get showSingleEmployer () { return this.employerId; }

  get securityRoute () {
    return this.partnerId ? EmployerRoutes.PartnerSecurity : null;
  }
}
